import { CustomerType } from "@origin-digital/platform-enums";
import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const lpgPaymentSchedule: IMcAppType = {
  name: "lpgPaymentSchedule",
  path: "/my/payment-settings/schedule",
  description: "Payment Schedule",
  navFlow: NavFlow.FOCUS,
  title: "Payment Schedule",
  parent: Tab.MORE,

  conditions: {
    intent: "lpgPaymentSchedule",
    customerType: CustomerType.kraken,
  },
};
